module.exports = __webpack_public_path__ + "static/media/marketing.e90b6491.jpg";